import { defineStore } from 'pinia'
import router from '@/router'

export const usePlayGame = defineStore('PlayGame', {
  actions: {
    playNow() {
      const isMSCW = router.currentRoute.value.path.includes('/mscw')
      if (isMSCW) {
        window.nexon.play('mscw')
      } else {
        window.nexon.play()
      }
    },
  },
})
